import React, { useEffect, useState } from 'react';
import HeroScreen from '../../../Views/HeroScreen';
import SEOHead from '../../SEO/SEOHead';

const AnimeCharacters = () => {
    const [characterList, setCharacterList] = useState([]);
    const [loading, setLoading] = useState(true);

    // Fetch Anime Characters Data from Jikan API
    useEffect(() => {
        const fetchAnimeCharacters = async () => {
            try {
                const response = await fetch('https://api.jikan.moe/v4/characters');
                const data = await response.json();
                setCharacterList(data.data || []);
                setLoading(false);
            } catch (error) {
                console.error('Error fetching anime characters:', error);
                setCharacterList([]);
                setLoading(false);
            }
        };
        fetchAnimeCharacters();
    }, []);

    return (
        <div className="anime-page-characters">
            <SEOHead title="ChibiDash | Anime Characters" description="Explore popular anime characters. Find your favorite characters from top anime series on ChibiDash." path="/animehub/characters" />
            {/* Hero Section */}
            <HeroScreen apiUrl="https://api.jikan.moe/v4/characters" />

            {/* Character List Section */}
            <h2 className="small-cards-title">Explore More Anime Characters</h2>
            {loading ? (
                <p className="loading-text">Loading Characters...</p>
            ) : (
                <div className="small-anime-grid">
                    {characterList.map((character) => (
                        <div key={character.mal_id} className="small-anime-card">
                            <img
                                src={character.images?.jpg?.image_url}
                                alt={character.name}
                                className="small-anime-image"
                            />
                            <div className="small-anime-info">
                                <h3 className="small-anime-title">{character.name}</h3>
                                <p className="small-anime-score">⭐ {character.favorites || 'N/A'}</p>
                                <button className="small-card-button">View</button>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default AnimeCharacters;
